'use client';

import { useState } from 'react';

/**
 * Course description block — 1:1 with legacy
 * `PopStoreCourseDescription.tsx`:
 *   - 200-char preview, full text on tap
 *   - "Show More"/"Show Less" toggle below the body
 *   - Title (the course name) on top, large + bold; renders even with no body
 *
 * Chrome-less + color-agnostic: no background of its own, and text is
 * `currentColor` so it inherits the host's contrasting color (the banner-tinted
 * hero, or white in the dark creator modal). The host provides padding.
 */
const TRUNCATE_LENGTH = 200;

export function CourseDescription({
  description,
  title,
}: {
  description?: string;
  title?: string;
}) {
  const [expanded, setExpanded] = useState(false);

  if (!title && !description) return null;

  const isOverflow = !!description && description.length > TRUNCATE_LENGTH;
  const body =
    description == null
      ? null
      : expanded || !isOverflow
        ? description
        : `${description.slice(0, TRUNCATE_LENGTH)}...`;

  return (
    <div className="flex flex-col gap-2">
      {title ? <p className="text-title-lg leading-tight">{title}</p> : null}
      {body != null ? (
        <p className="text-sub whitespace-pre-wrap font-normal leading-[21px]">
          {body}
        </p>
      ) : null}
      {isOverflow ? (
        <button
          type="button"
          onClick={() => setExpanded(prev => !prev)}
          className="text-sub self-start underline opacity-80 transition hover:opacity-100"
        >
          {expanded ? 'Show Less' : 'Show More'}
        </button>
      ) : null}
    </div>
  );
}
